import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  fetchCompany,
  setCompany,
  setCompanyForm,
  deleteCompany,
} from '../../../store/modules/company';
import { deleteFile } from '../../../store/modules/file';

import Company from '../components/Company';
import { restoreObject } from '../../../store/modules/totaldata';

const _ = require('lodash');

const mapActionCreators = {
  fetchCompany,
  setCompany,
  deleteCompany,
  setCompanyForm,
  deleteFile,
  push,
  restoreObject,
};

const mapStateToProps = state => ({
  company: state.company.companies[state.company.current],
  formOpen: state.company.formOpen,
  companyId: state.company.current,
  companies: state.company.companies,
  companyCount: Object.keys(
    _.filter(state.company.companies, o => o.deleted_at === null),
  ).length,
  activities: _.filter(
    _.pick(
      state.activity.activities,
      state.company.companies[state.company.current]
        ? state.company.companies[state.company.current].activities
        : null,
    ),
    ['deleted_at', null],
  ),
  activitiesInvolved: _.filter(
    _.pick(
      state.activity.activities,
      state.company.companies[state.company.current]
        ? state.company.companies[state.company.current].activities_involved
        : null,
    ),
    ['deleted_at', null],
  ),
  projects: _.filter(
    _.pick(
      state.project.projects,
      state.company.companies[state.company.current]
        ? state.company.companies[state.company.current].projects
        : null,
    ),
    ['deleted_at', null],
  ),
  files: _.filter(
    _.pick(
      state.file.files,
      state.company.companies[state.company.current]
        ? state.company.companies[state.company.current].files
        : null,
    ),
    ['deleted_at', null],
  ),
  tasks: _.filter(
    _.pick(
      state.task.tasks,
      state.company.companies[state.company.current]
        ? state.company.companies[state.company.current].tasks
        : null,
    ),
    ['deleted_at', null],
  ),
  persons: _.filter(
    _.pick(
      state.person.persons,
      state.company.companies[state.company.current]
        ? state.company.companies[state.company.current].persons
        : null,
    ),
    ['deleted_at', null],
  ),
  staffs: _.filter(state.staff.staffs, ['deleted_at', null]),
  fetching: state.company.fetching,
});

export default connect(mapStateToProps, mapActionCreators)(Company);



// WEBPACK FOOTER //
// ./src/routes/CompanyDetail/containers/CompanyContainer.js